import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { MatDialog, MatDialogRef, MatDialogState } from '@angular/material/dialog';

import { NSCommonConstants } from '@ruby/configs/common.constants';
import { ICustomer } from '@ruby/modules/customer-select/models/customer.interface';
import { IThirdPartyLOA } from '@ruby/modules/third-party/models/third-party.interface';
import { ThirdPartyRequestEidContainerComponent } from '@ruby/shared/dialogs/third-party/container/third-party-request-eid/third-party-request-eid.container';

@Component({
  selector: 'ng-select-company',
  templateUrl: './select-company.component.html',
  styleUrls: ['./select-company.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SelectCompanyComponent implements OnChanges {
  @Input() customers!: Array<ICustomer>;
  @Input() contractToUpdate?: IThirdPartyLOA;
  @Input() isEdit!: boolean;
  @Output() selected = new EventEmitter<ICustomer>();
  @Output() nextEmitter = new EventEmitter();
  selectedCustomer?: ICustomer;
  dialogRef?: MatDialogRef<ThirdPartyRequestEidContainerComponent>;

  constructor(private dialogSvc: MatDialog) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.customers && changes.customers.currentValue.length === 1 && !this.isEdit) {
      this.selectCustomer(changes.customers.currentValue[0], true);
    }

    if (this.customers.length > 0) {
      const customer: ICustomer | undefined = this.customers.find((item) =>
        this.contractToUpdate && item.customerIdentifier.padEnd(10, '0') === this.contractToUpdate.companyEid);
      if (customer) {
        this.selectCustomer(customer);
      }
    }
  }

  /**
   * Select Customer
   *
   * @summary The following method selects a customer and enable the next button
   * @param $customer: ICustomer
   * @param next: boolean
   * @returns void
   */
  selectCustomer($customer: ICustomer, next: boolean = false): void {
    if (this.dialogRef?.getState() !== MatDialogState.OPEN) {
      if (!$customer.customerIdentifier || !(NSCommonConstants.validEId.test($customer.customerIdentifier))) {
        this.selectedCustomer = undefined;
        this.dialogRef = this.dialogSvc.open(ThirdPartyRequestEidContainerComponent, {
          width: '40%',
          height: '75%'
        });
      } else {
        this.selectedCustomer = $customer;
        this.selected.emit(this.selectedCustomer);
        if (next) {
          this.nextEmitter.emit();
        }
      }
    }
  }

  /**
   * Next
   *
   * @summary The following method emits the selected customer and go to next step
   * @returns void
   */
  next(): void {
    this.selected.emit(this.selectedCustomer);
  }
}
